import { render, staticRenderFns } from "./TipNoMatch.vue?vue&type=template&id=621a5b59&scoped=true"
import script from "./TipNoMatch.vue?vue&type=script&lang=js"
export * from "./TipNoMatch.vue?vue&type=script&lang=js"
import style0 from "./TipNoMatch.vue?vue&type=style&index=0&id=621a5b59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a5b59",
  null
  
)

export default component.exports